import { StvV2Provider } from '@amagimedia/commons/src/Provider/StvV2Provider';
import type { FC } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { STVContentPartnerApp } from './components/STVContentPartnerApp';
import { STVV2LandingApp } from './components/STVV2LandingApp';
import { VerifiedLoginRoute } from './components/VerifiedLoginRoute';

export const App: FC = () => {
  return (
    <StvV2Provider stylesPrefix="stv-v2-host">
      <BrowserRouter>
        <Switch>
          <Route
            path={[
              '/:deployment/partner',
              '/partner',
              '/:deployment/boat',
              '/boat',
            ]}
          >
            <STVContentPartnerApp />
          </Route>
          <VerifiedLoginRoute path={['/']} component={STVV2LandingApp} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </StvV2Provider>
  );
};
